// extracted by mini-css-extract-plugin
export var border = "_24-8";
export var brand = "_24-t";
export var button = "_24-l";
export var center = "_24-a";
export var centered = "_24-6";
export var closeButton = "_24-c";
export var disabledWrapper = "_24-m";
export var error = "_24-p";
export var extraLarge = "_24-4";
export var extraSmall = "_24-1";
export var fill = "_24-i";
export var footer = "_24-h";
export var footerAction = "_24-j";
export var footerButtons = "_24-k";
export var header = "_24-7";
export var headerWithClose = "_24-d";
export var icon = "_24-o";
export var info = "_24-s";
export var inline = "_24-9";
export var large = "_24-3";
export var main = "_24-e";
export var modal = "_24-0";
export var nearFull = "_24-5";
export var neutral = "_24-u";
export var noPadding = "_24-g";
export var none = "_24-v";
export var scrollable = "_24-f";
export var small = "_24-2";
export var success = "_24-r";
export var tight = "_24-n";
export var titleIcon = "_24-b";
export var warn = "_24-q";